import React from 'react';
import { faLevelUpAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InfoTooltip from '../../components/info-tooltip/info-tooltip';
import { InfoTooltipVariant } from '../../components/info-tooltip/info-tooltip-variant';
import './InvitedFromOtherDomainName.scss';

const OTHER_DOMAIN_TOOLTIP =
    'Invited by a team member from a different email domain.';

interface InvitedFromOtherDomainNameProps {
    name: string;
    isInvitedFromOtherDomain?: boolean;
    isIndented?: boolean;
}

export const InvitedFromOtherDomainName = (
    props: InvitedFromOtherDomainNameProps
) => (
    <span
        className={
            props.isIndented
                ? 'team-member-name team-member-name--invited'
                : 'team-member-name'
        }>
        {props.isIndented && (
            <FontAwesomeIcon
                icon={faLevelUpAlt}
                rotation={90}
                className="team-member-name__invited-icon"
            />
        )}
        {props.name}
        {props.isInvitedFromOtherDomain && (
            <InfoTooltip
                text={OTHER_DOMAIN_TOOLTIP}
                variant={InfoTooltipVariant.Warning}
            />
        )}
    </span>
);
